import { render, staticRenderFns } from "./ModerationDistributionsFilter.vue?vue&type=template&id=760e477b&"
import script from "./ModerationDistributionsFilter.vue?vue&type=script&lang=ts&"
export * from "./ModerationDistributionsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports